import { render, staticRenderFns } from "./add-channel-dialog.vue?vue&type=template&id=6eb0de0f&scoped=true&"
import script from "./add-channel-dialog.vue?vue&type=script&lang=ts&"
export * from "./add-channel-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./add-channel-dialog.vue?vue&type=style&index=0&id=6eb0de0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb0de0f",
  null
  
)

export default component.exports